"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgemsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgemsm` : '') + (description ? ` desc-brandedgemsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgemsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgemsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.33 0 .02 6.73h6.87L4.33 0Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.23 6.73 17.86 0 22 6.73h-6.87.1Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.13 0h-6.8l2.65 7 4.15-7Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.12 0h6.74l-2.6 7-4.14-7Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.98 6.73 11.12 0l4.15 6.73H6.98Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.12 19 0 6.7h6.98L11.12 19Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.12 19 22 6.7h-6.86L11.12 19Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.25 6.7H6.98L11.12 19l4.13-12.3Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedgemsm;